module.exports = __webpack_public_path__ + "assets/img/3c94e8d6a41d8ceb3eac9007e0287d92.svg";